export const PROTOCOL_BUILDER_REQUEST_START = 'PROTOCOL_BUILDER_REQUEST_START';
export const PROTOCOL_BUILDER_REQUEST_SUCCESS = 'PROTOCOL_BUILDER_REQUEST_SUCCESS';
export const PROTOCOL_BUILDER_REQUEST_FAILURE = 'PROTOCOL_BUILDER_REQUEST_FAILURE';
